import React from "react";
import { ShopByCategoryCard } from "./ShopByCategoryCard";
import { useAppDispatch, useAppSelector } from "../../../../State/Store";
import { getProductsByCategoryId } from "../../../../State/customer/ProductSlice";
import { useNavigate } from "react-router-dom";

export const ShopByCategory = () => {
  const {homeCategory} = useAppSelector(store=>store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const handleClick = async(categoryId:string,pageNumber:number) => { 
    await dispatch(getProductsByCategoryId({categoryId,pageNumber}))
    navigate(`/products/${categoryId}?page=${pageNumber}`)
   }
  return (
    <>
      <h1  className="text-lg lg:text-4xl font-bold text-primary py-5  text-center">
        SHOP BY CATEGORY
      </h1>
      <div className=" grid-cols-1  p-5 grid md:grid-cols-3  xl:grid-cols-4 2xl:grid-cols-5 space-y-2 w-[90%] mx-auto">
        {homeCategory.homePageData?.shopByCategories
          .map((item, index) => (
            <ShopByCategoryCard handleClick={handleClick}  item={item} key={index} />
          ))}
      </div>
    </>
  );
};
